
export class HttpRepositoryResponse<TType> {
  public hasErrors: boolean = false;
  public statusCode: number = 200;
  public error: string = '';

  constructor(public data: TType) {

  }
}
